import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import cn from 'classnames'

import Textarea from '../../Core/Textarea/Textarea';
import classes from './styles.module.scss';

const EditComment = forwardRef(({onClose, onSubmit}, ref) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({})

  useImperativeHandle(ref, () => ({
    open: ({value, title, hideLimit = false, data}) => {
      setForm({
        value: value || '',
        title: title || t('Edit Comment'),
        hideLimit: hideLimit,
        data: data || {},
      })
      setLoading(false)
      setIsOpen(true)
    },
    close: handleClose
  }))
  
  const handleInputChange = (event) => {
    const { value } = event.target
    setForm(prev => ({...prev, value: value.slice(0, 2000)}))
  };

  const handleDropdownInputChange = (cat) => (event) => {
    const { value } = event.target
    setForm(prev => {
      const dropdown_fields = prev.data.dropdown_fields.map(f => {
        if (f.id === cat.id) {
          return {
            ...f,
            value: value.slice(0, 2000),
          }
        }
        return f
      })
      return {
        ...prev,
        data: {
          ...prev.data,
          dropdown_fields,
        }
      }
    })
  }
  
  const handleClickSave = () => {
    setLoading(true)
    onSubmit(form)
  }

  const handleClose = () => {
    setIsOpen(false)
    if (onClose) {
      onClose()
    }
  }

  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      maxWidth='xs'
      classes={{ paper: classes.modal }}
    >
      <div className={classes.container}>
        <div className={classes.header}>
          <div className={classes.label}>{form.title}</div>
          <IconButton aria-label='close' onClick={handleClose} className={classes.closeButton}>
            <CloseIcon />
          </IconButton>
        </div>
        {
          Array.isArray(form.data?.dropdown_fields)
            ? form.data.dropdown_fields.map((field) => {
                return (
                  <div className={classes.editEntry} key={field.id}>
                    <div className={classes.dropdownName}>{field.name}</div>
                    <Textarea
                      onChange={handleDropdownInputChange(field)}
                      name='comment'
                      value={field.value}
                      wrapperClass={cn(classes.textareaWrapper, classes.dropdownField)}
                      className={cn(classes.textarea, classes.dropdownField)}
                    />
                  </div>
                )
              })
            : <div className={classes.editEntry}>
                <Textarea
                  onChange={handleInputChange}
                  name='comment'
                  value={form.value}
                  wrapperClass={classes.textareaWrapper}
                  className={classes.textarea}
                />
              </div>
        }
        {
          !form.hideLimit
            ? <div className={classes.counter}>
                {form.value?.length || 0}/2000
              </div>
            : null
        }
      </div>
      <div>
        <button onClick={handleClickSave} disabled={loading} className={classes.buttonSave}>
          { loading ? <div className={classes.loader} /> : t('Save & Close') }
        </button>
      </div>
    </Dialog>
  );
})

export default EditComment

